import { classNames } from '@/utils';
import React from 'react';
import { StepProgress } from './StepProgress';

interface OnboardingCardProps {
  currentStep: number;
  totalSteps: number;
  title?: string;
  description?: string;
  noPadding?: boolean;
  hideProgress?: boolean;
  children: React.ReactNode;
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({
  currentStep,
  totalSteps,
  title,
  description,
  noPadding,
  hideProgress,
  children,
}) => {
  return (
    <div
      className={classNames(
        'mx-auto flex w-full flex-col items-start justify-center gap-2.5 rounded-[26px] bg-white shadow-xl sm:w-[600px]',
        !noPadding && 'px-6 py-10 sm:px-12 lg:px-[50px]',
      )}
    >
      <div className="flex w-full flex-col items-start justify-start gap-8">
        {(!hideProgress || !!title || !!description) && (
          <div className="flex w-full flex-col items-start justify-start gap-6">
            {!hideProgress && (
              <StepProgress totalSteps={totalSteps} currentStep={currentStep} />
            )}
            {(!!title || !!description) && (
              <div className="flex w-full flex-col items-start justify-start gap-6">
                <div className="relative flex w-full flex-col items-start justify-start gap-2">
                  {!!title && (
                    <p className="w-full text-left text-2xl font-medium text-[#141c25] transition-opacity duration-300">
                      {title}
                    </p>
                  )}
                  {!!description && (
                    <p className="w-full text-left text-sm text-[#414e62] transition-opacity duration-300">
                      {description}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        <div className="flex w-full flex-col items-start justify-start gap-4 transition-all duration-300">
          {children}
        </div>
      </div>
    </div>
  );
};
